import { useTranslation } from "react-i18next";
import { Navigate, useLocation } from "react-router";
import { ListNavLayout } from "@/components/ListNavLayout";
import { ProfileSummary } from "./profile/ProfileSummary";
import { useSettingsNav } from "./settingsNav";

const LEGACY_TABS: Record<string, string> = {
  profile: "/settings",
  appearance: "/settings/appearance",
  ai_preferences: "/settings/ai",
  notifications: "/settings/notifications",
  security: "/settings/security",
  rally: "/settings/rally",
  harness: "/settings/rally",
  teams: "/settings/teams",
  integrations: "/settings/connections",
  extensions: "/settings/connections",
  authorizations: "/settings/authorizations",
  usage: "/settings/usage",
};

function withoutTrailingSlashes(path: string): string {
  let end = path.length;
  while (end > 0 && path[end - 1] === "/") end -= 1;
  return path.slice(0, end);
}

export function legacyTabTarget(pathname: string, search: string): string | null {
  const params = new URLSearchParams(search);
  const tab = params.get("tab");
  if (tab === null || withoutTrailingSlashes(pathname) !== "/settings") return null;
  params.delete("tab");
  const rest = params.toString();
  const query = rest ? `?${rest}` : "";
  return `${LEGACY_TABS[tab] ?? "/settings"}${query}`;
}

export function SettingsLayout() {
  const { t } = useTranslation("settings");
  const groups = useSettingsNav();
  const { pathname, search } = useLocation();
  const legacy = legacyTabTarget(pathname, search);
  if (legacy) return <Navigate to={legacy} replace />;
  return (
    <ListNavLayout
      basePath="/settings"
      title={t("title")}
      subtitle={t("subtitle")}
      groups={groups}
      defaultTo="/settings"
      mobileIntro={<ProfileSummary />}
      aria-label={t("nav.label")}
    />
  );
}
